var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3076_238312)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5001 41.86C34.9213 41.86 44.1801 32.6013 44.1801 21.18C44.1801 9.75875 34.9213 0.5 23.5001 0.5C12.0788 0.5 2.82007 9.75875 2.82007 21.18C2.82007 27.6109 5.7555 33.3563 10.3596 37.1492C10.3669 37.1552 10.3604 37.1669 10.3514 37.1639V37.1639C10.3458 37.162 10.3401 37.1661 10.3401 37.1719V41.9452C10.3401 44.4929 13.0254 46.1464 15.3003 44.9996L20.6696 42.293C21.333 41.9586 22.0763 41.825 22.8189 41.849C23.045 41.8563 23.2721 41.86 23.5001 41.86Z",
    fill: "#851D41"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3076_238312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2501 26.6702C33.4888 26.903 33.6782 27.1814 33.8071 27.4889C33.9359 27.7965 34.0016 28.1268 34.0001 28.4602C34.0004 28.5975 33.9904 28.7346 33.9701 28.8704C33.8877 29.3944 33.6425 29.8793 33.2692 30.2562C32.8958 30.6331 32.4133 30.8829 31.8901 30.9702C31.7486 30.9988 31.6044 31.0123 31.4601 31.0102C31.127 31.0094 30.7973 30.9428 30.4901 30.8141C30.1829 30.6853 29.9042 30.4971 29.6701 30.2602L24.0001 24.5903L18.3401 30.2602C17.8613 30.736 17.2151 31.0053 16.5401 31.0102C16.0371 31.0105 15.5453 30.8614 15.1272 30.5818C14.7091 30.3021 14.3835 29.9046 14.1918 29.4396C14 28.9746 13.9507 28.4631 14.0501 27.9701C14.1495 27.477 14.3931 27.0246 14.7501 26.6702L20.4201 21.0102L14.7501 15.3403C14.5124 15.1046 14.3238 14.8242 14.1951 14.5152C14.0663 14.2063 14.0001 13.8749 14.0001 13.5402C13.9992 13.2069 14.0651 12.8767 14.1939 12.5693C14.3227 12.2619 14.5118 11.9833 14.7501 11.7502C15.2334 11.2881 15.8764 11.0302 16.5451 11.0302C17.2138 11.0302 17.8567 11.2881 18.3401 11.7502L24.0101 17.4202L29.6701 11.7502C29.9042 11.5133 30.1829 11.3251 30.4901 11.1964C30.7973 11.0676 31.127 11.001 31.4601 11.0002C31.6044 10.9982 31.7486 11.0116 31.8901 11.0402C32.4119 11.127 32.8934 11.3754 33.2665 11.7504C33.6397 12.1254 33.8858 12.608 33.9701 13.1303C33.9904 13.266 34.0004 13.403 34.0001 13.5402C34.0016 13.8751 33.936 14.207 33.8072 14.5161C33.6784 14.8253 33.489 15.1055 33.2501 15.3403L27.5901 21.0002L33.2501 26.6702Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3076_238312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3076_238312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20.01,
    fill: "white",
    transform: "translate(14 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.9eb0e0d1d7072679b8c3efbae80e55b7.svg";
export { ForwardRef as ReactComponent };